import { Card, Text, Flex } from '@mantine/core';
import { theme } from '@/theme/theme';

type DisclaimerCardProps = {
  title: string;
  description: string;
  imgUrl?: string;
};
export const DisclaimerCard = ({
  title,
  description,
  imgUrl,
  ...otherProps
}: DisclaimerCardProps) => (
  <Card withBorder radius="md" {...otherProps}>
    <Flex
      align="center"
      mb="lg"
      gap="xs"
      pb="xs"
      style={{
        borderBottom: `1px solid ${theme?.colors?.gray?.[3]}`,
      }}
    >
      {imgUrl && <img src={imgUrl} alt="" loading="lazy" className="icon-s3" />}
      <Text
        fw={600}
        fz={{
          base: '12px',
          sm: 'md',
        }}
        className="md-line-height"
      >
        {title}
      </Text>
    </Flex>

    <Text
      className="md-line-height"
      fz={{
        base: '12px',
        sm: 'md',
      }}
      color={theme?.colors?.gray?.[7]}
    >
      {description}
    </Text>
  </Card>
);
